import { useCallback } from 'react';
import { usePostHog } from 'posthog-js/react';

import { PostHogEventData } from '@hcs/types';

import { usePostHogEnabled } from './usePostHogEnabled';

export const useLogPostHogEvent = () => {
  const postHog = usePostHog();
  const isPostHogEnabled = usePostHogEnabled();

  return useCallback(
    (event_name: string, event_data: PostHogEventData) => {
      // check for self user and ensure we are in a postHog Provider
      // __loaded will be false if we are not in a PostHog Provider
      if (postHog && isPostHogEnabled) {
        postHog.capture(event_name, event_data);
      }
    },
    [postHog, isPostHogEnabled],
  );
};
